import { List } from '@radix-ui/react-navigation-menu'

import { styled } from '~/styled'

const StyledList = styled(List, {
  base: [
    '[--navigation-menu-vertical-item-pl:--spacing(4)]',
    '*:not-first:mt-0.5'
  ]
})

export const NavigationMenuVerticalList = StyledList
